import React, { useEffect, useState } from "react";
import api_requests from "../../resources/api_requests";
import { useNavigate, useParams } from "react-router-dom";
import ImageLinks from "../../assets/Images/ImagesLink";
import Loader from "../../modules/Loader";
import toast from "react-hot-toast";
import Footer from "../../Footer";
import ConfirmClose from "../../modules/modals/ConfirmClose";
import { useTranslation } from "react-i18next";

const AddressDetails = () => {
  const { addressId } = useParams();
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [refresh, set_refresh] = useState(false);
  const [address, setAddress] = useState(null);
  const [poc, setPoc] = useState(null);
  const [delete_confirm, set_delete_confirm] = useState({
    open: false,
    id: "",
  });
  const { t } = useTranslation();

  const get_address = async () => {
    setLoading(true);
    try {
      const response = await api_requests.get_saved_address({
        recent_count: 0,
        saved_count: 20,
        master_zone_id: 0,
      });

      const all_addresses = response?.data?.saved || [];
      const current_address_id = Number(addressId);

      const current_address = all_addresses.find(
        (addr) => addr.id === current_address_id,
      );

      setAddress(current_address || null);
      setPoc(current_address?.poc?.[0] || null);
    } catch (error) {
      toast.error(t("failed_to_get_address"));
    } finally {
      setLoading(false);
    }
  };

  const handle_delete_confirm = async () => {
    try {
      set_delete_confirm({ open: false, id: "" });
      setLoading(true);
      await api_requests.delete_address(delete_confirm.id);
      navigate(-1);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    get_address();
  }, []);

  useEffect(() => {
    if (refresh) {
      get_address();
      set_refresh(false);
    }
  }, [refresh]);

  if (isLoading || !address) {
    return <Loader />;
  }

  return (
    <div className="min-h-screen px-6 py-5 overflow-hidden h-[100vh]">
      <div
        className="flex items-center gap-1.5 cursor-pointer"
        onClick={() => navigate(-1)}
      >
        <img
          src={ImageLinks.chevron_right}
          className="w-[18px] h-[19px]"
          alt="back"
        />
        <p className="font-custom text-sm font-semibold text-dark_black">
          {t("address_details")}
        </p>
      </div>

      <div className="shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)] rounded-[20px] py-5 px-6 mt-4">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-1">
            <span className="text-primary text-xs font-semibold">
              {t("location")}
            </span>
            <span className="text-sm text-dark_black font-medium">
              {address.google_maps_address}
            </span>
          </div>

          <div className="flex flex-col gap-1">
            <span className="text-primary text-xs font-semibold">
              {t("address")}
            </span>
            <span className="text-sm text-dark_black font-medium">
              {address.address_line1}
            </span>
          </div>

          <div className="flex flex-wrap justify-between items-center">
            <div className="flex flex-col gap-1">
              <span className="text-primary text-xs font-semibold">
                {t("full_name")}
              </span>
              <span className="text-sm text-dark_black font-medium">
                {poc?.name}
              </span>
            </div>

            <div className="flex flex-col gap-1">
              <span className="text-primary text-xs font-semibold">
                {t("mobile_number")}
              </span>
              <span className="text-sm text-dark_black font-medium">
                {poc?.mobile}
              </span>
            </div>
          </div>

          {address.label && (
            <div className="flex flex-col gap-1">
              <span className="text-primary text-xs font-semibold">
                {t("address_label")}
              </span>
              <span className="text-sm text-dark_black font-medium">
                {address.label}
              </span>
            </div>
          )}

          <button
            className="text-[#BC0000] border-[#BC0000] rounded-[30px] border-[1.5px] w-[109px] mx-auto py-1 font-semibold text-base"
            onClick={() =>
              set_delete_confirm({ open: true, id: Number(addressId) })
            }
          >
            {t("delete")}
          </button>
        </div>
      </div>
      <Footer bottom={0} />
      {delete_confirm.open && (
        <ConfirmClose
          close={() => set_delete_confirm({ open: false, id: "" })}
          main_title={t("want_to_delete")}
          sub_title=""
          cancel_button_text={t("canel")}
          action_button_text={t("delete")}
          cancel_button={() => set_delete_confirm({ open: false, id: "" })}
          action_button={handle_delete_confirm}
        />
      )}
    </div>
  );
};

export default AddressDetails;
